<template>
  <tr v-if="amount > 0">
    <td>
      <div v-if="unitIsSqm"> {{ displayName }} {{ amount }}m<sup>2</sup></div>
      <div v-if="unitIsPc">{{ amount }}x {{ displayName }}</div>
      <small v-if="unitIsPc && hasModifiedCount">
        ({{ countDiff }} {{ $t('labels.inclusive_abbreviation')}}.)
      </small>
      <small v-if="unitIsSqm && hasModifiedCount">
        ({{ countDiff }} /m<sup>2</sup> {{ $t('labels.inclusive_abbreviation')}}.)
      </small>
    </td>
    <td class="text-right width--25">{{ $filters.formatMoney(totalNet) }}</td>
  </tr>
</template>

<script setup>
import { UNIT_PC, UNIT_SQM } from '@/constants'
import { useMainStore } from '@/store'
import { computed } from 'vue'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()
// define passed props
const props = defineProps({
  article: {
    type: Object,
    required: true
  }
})
// define computed props
const locale = computed(() => store.settings.locale)
const shoppingCart = computed(() => store.settings.shopping_cart)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const displayName = computed(() => {
  return (locale.value === 'en') ? props.article.name_en : props.article.name
})

const squareMeter = computed(() => {
  return shoppingCart.value.width * shoppingCart.value.depth
})

const amount = computed(() => {
  // if (props.article.unit === UNIT_SQM) {
  //   return Math.floor(squareMeter.value * props.article.count)
  // }

  return props.article.count
})

const unitIsPc = computed(() => {
  return props.article.unit === UNIT_PC
})

const unitIsSqm = computed(() => {
  return props.article.unit === UNIT_SQM
})

const hasModifiedCount = computed(() => {
  if (!props.article.hasOwnProperty('count_after_inclusive')) {
    return false
  }

  return props.article.count !== props.article.count_after_inclusive
})

const countDiff = computed(() => {
  if (hasModifiedCount.value) {
    return props.article.count - props.article.count_after_inclusive
  }

  return 0
})

const totalNet = computed(() => {
  let count = 0
  if (unitIsSqm.value) {
    //calculate inclusive sqm with current booth size
    let boothInclusive = props.article.inclusive * squareMeter.value
    count = ((props.article.count - props.article.inclusive) > 0)
      ? (props.article.count - boothInclusive)
      : 0
  } else {
    count = ((props.article.count - props.article.inclusive) > 0)
      ? (props.article.count - props.article.inclusive)
      : 0
  }

  if (hasModifiedCount.value) {
    count = props.article.count_after_inclusive
  }

  let value = count * parseFloat(props.article.print_inclusive ? 0 : props.article.exhibitionPrices.price_net)

  return (!earlyBirdMode.value) ? value : addLateDeliverySurcharge(value, lateDelivery.value)
})
</script>